// DemandPlanner duck module

// Actions
const SET_DEMAND_PLANNER_DATA = 'demandPlanner/SET_DEMAND_PLANNER_DATA';
const LOAD_DEMAND_DATA = 'demandPlanner/LOAD_DEMAND_DATA';
const LOAD_DEMAND_DATA_SUCCESS = 'demandPlanner/LOAD_DEMAND_DATA_SUCCESS';
const LOAD_DEMAND_DATA_ERROR = 'demandPlanner/LOAD_DEMAND_DATA_ERROR';

// Action Creators
export const setDemandPlannerData = (data) => ({
  type: SET_DEMAND_PLANNER_DATA,
  payload: data,
});

export const loadDemandData = () => ({
  type: LOAD_DEMAND_DATA,
});

export const loadDemandDataSuccess = (data) => ({
  type: LOAD_DEMAND_DATA_SUCCESS,
  payload: data,
});

export const loadDemandDataError = (error) => ({
  type: LOAD_DEMAND_DATA_ERROR,
  payload: error,
});

// Initial State
const initialState = {
  demandPlanner: {},
  demandData: [],
  loading: false,
  error: null,
};

// Reducer
export default function demandPlannerReducer(state = initialState, action) {
  switch (action.type) {
    case SET_DEMAND_PLANNER_DATA:
      return {
        ...state,
        demandPlanner: action.payload,
      };
    case LOAD_DEMAND_DATA:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case LOAD_DEMAND_DATA_SUCCESS:
      return {
        ...state,
        demandData: action.payload,
        loading: false,
        error: null,
      };
    case LOAD_DEMAND_DATA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}

// Operations (thunks, etc.)
export const demandPlannerOperations = {
  setDemandPlannerData,
  loadDemandData,
  loadDemandDataSuccess,
  loadDemandDataError,
}; 